export default "__VITE_PUBLIC_ASSET__7df4f0e3__"